import { SVGInterface } from "../../interface";

const CaretDuoDown = ({ color, ...rest }: SVGInterface) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      d="M3.77 9L2 10.77L12 20.77L22 10.77L20.23 9L12 17.23L3.77 9Z"
      fill={color || "#0E171F"}
    />
    <path
      d="M3.77 3L2 4.77L12 14.77L22 4.77L20.23 3L12 11.23L3.77 3Z"
      fill={color || "#0E171F"}
    />
  </svg>
);

export default CaretDuoDown;
